<template>
  <va-modal
    size="large"
    id="flowStatsModal"
    ref="flowStatsModal"
    class="flowStatsModal"
    v-model="showFlowStatsModal"
    :showOkay="false"
    :cancelText="$t('modal.close')"
    @cancel="closeModal"
  >

    <div slot="header" class="modal-title">
      {{ getTitleHeader }}
    </div>

    <div class="wrapper">
      <div v-if="isLoading" class="loading-overlay">
        <LoadingPlaceholder />
      </div>
      <div class="container" v-if="statsData !== null">
        <div class="row">
          <label class="is-bold"> {{ this.$t('iframe.table_headings.project_name') }}:&ensp;</label>
          <span>{{this.flow.name}}</span>
        </div>

        <div class="row">
          <label class="is-bold"> {{ this.$t('iframe.table_headings.client') }}:&ensp;</label>
          <span>{{this.flow.client.name}}</span>
        </div>

        <div class="row mt-2 no-gutters evollu-form">
          <div class="row">
            <div class="col-12 col-md-6 pl-0">
              <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
              <RangeDatePicker
                id="date-filter-picker"
                v-model="filters.date"
                class="col-12 pl-0"
                :placeholder="$t('optometry.leads.date_range')"/>
            </div>
          </div>
        </div>

        <div class="row">
          <va-card class="w-100">
            <h3>{{ this.$t('iframe.statistics.sessions.totals') }}</h3>
            <div class="row">
              <label class="is-bold"> {{ this.$t('iframe.statistics.sessions.total_initiated') }}: </label>
              <label>{{ this.statsData.totalSessions }}</label>
            </div>
            <div class="row">
              <label class="is-bold"> {{ this.$t('iframe.statistics.sessions.total_finished') }}: </label>
              <label>{{ this.statsData.finishedSessions }}</label>
            </div>

            <label style="font-size: 22px; color: #29C4AA; font-weight: bold">{{ $t('iframe.statistics.sessions.actions_record') }}</label>
            <div class="row" v-for="(elem, index) in statsData.actionsRecordTotalDistinct">
              <label class="is-bold"> {{ $t(`iframe.statistics.sessions.${index}`) }}: </label>
              <label>{{ elem }}</label>
            </div>
          </va-card>
        </div>
        <div class="row mt-2">
          <va-card class="w-100">
            <h3>{{ this.$t('iframe.statistics.sessions.totals_per_page') }}</h3>
            <div class="row totalsGraph">
              <apexchart height="380" width="600" type="bar" :options="pagesVisitsStatsChartOptions" :series="pagesVisitsStatsSeries"></apexchart>
            </div>
          </va-card>
        </div>
        <div class="row">
          <va-card class="w-100">
            <h3>{{ this.$t('iframe.statistics.sessions.mean_secs_per_page') }}</h3>
            <div class="row totalsGraph">
              <apexchart height="380" width="600" type="bar" :options="pagesAvgTimeStatsChartOptions" :series="pagesAvgTimeStatsSeries"></apexchart>
            </div>
          </va-card>
        </div>

      </div>
    </div>


  </va-modal>

</template>

<script>
import { IframeService } from "@/api/IframeService";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import RangeDatePicker from "@/components/common/RangeDatePicker.vue";

export default {
  components: { RangeDatePicker, LoadingPlaceholder },
  props: {
    flow: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFlowStatsModal: false,
      statsData: null,
      isLoading: false,
      filters: {
        date: {
          start: null,
          end: null,
        }
      },
      pagesVisitsStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#015a60'],
        dataLabels: {
          enabled: true
        },
      },
      pagesAvgTimeStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#6cb412'],
        dataLabels: {
          enabled: true
        },
      }

    };
  },
  async mounted() {
    this.showFlowStatsModal = true;
    this.isLoading = true
    await this.loadData();

  },
  methods: {
    async loadData() {
      this.isLoading = true
      this.statsData = await IframeService.getFlowStatistics(this.flow.hash, this.flow.client_id, this.filters.date.start, this.filters.date.end)
      this.isLoading = false

    },
    closeModal() {
      this.$emit('modalClosed')
      setTimeout(() => {
        this.showFlowStatsModal = false
      }, 500)
    }
  },
  computed: {
    getTitleHeader() {
      return this.$t('menu.iframe/statistics')
    },
    pagesVisitsStatsSeries: function() {
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.statsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: elem.totalVisited,
        })
      })
      return data
    },
    pagesAvgTimeStatsSeries: function() {
      /*let data = [
        {
          name: '',
          data: []
        }
      ]
      this.statsData.pageStats.forEach(elem => {
        data[0].data.push(Math.round(elem.avgTimeSpentSeconds))
      })
      return data*/
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.statsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: Math.round(elem.avgTimeSpentSeconds),
        })
      })
      return data
    },
    /*pagesAvgTimeStatsChartOptions: function () {
      let options = {
        chart: {
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
        },
        colors: ['#6cb412'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      }

      this.statsData.pageStats.forEach(elem => {
        options.xaxis.categories.push(elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`))
      })

      return options
    },*/
  },
  watch: {
    'filters.date.end': function() {
      this.loadData()
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.simple-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3; /* Ensure it appears above the table */
}
</style>
